import useDebounce from 'react-use/esm/useDebounce';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useTemplateSecrets } from '@backstage/plugin-scaffolder-react';
import { MicrosoftSignInProps } from './schema';
import { getAdditionalScopesFromConfig } from '../../utils';

export const MicrosoftSignIn = (
  props: MicrosoftSignInProps,
) => {
  const { uiSchema, onChange } = props;
  const config = useApi(configApiRef);

  const microsoftAuthApi = useApi(microsoftAuthApiRef);
  const { secrets, setSecrets } = useTemplateSecrets();

  const additionalScopesBase = getAdditionalScopesFromConfig(config);
  useDebounce(
    async () => {
      const { requestUserCredentials, additionalScopes: extraScopes } =
        uiSchema?.['ui:options'] ?? {};
      if (!requestUserCredentials) {
        // No need to request user credentials
        return;
      }

      // You already have the secrets
      if (secrets[requestUserCredentials.secretsKey]) return;

      const additionalScopes = Array.from(
        new Set([...additionalScopesBase, ...(extraScopes ?? [])]),
      );
      const token = await microsoftAuthApi.getAccessToken(additionalScopes);
      setSecrets({ [requestUserCredentials.secretsKey]: token });
      onChange('SIGNED IN');
    },
    10,
    [uiSchema],
  );
  // Just signing in and do not render anything
  return <></>;
};
